import { type PropsWithChildren } from "react";

import { ScrollbarScript, ToastProvider, Tooltip } from "./components";

export const LighthouseProvider = ({ children }: PropsWithChildren) => {
  return (
    <>
      <ScrollbarScript />
      <ToastProvider>
        <Tooltip.Provider delayDuration={100}>{children}</Tooltip.Provider>
      </ToastProvider>
    </>
  );
};

export default LighthouseProvider;
